import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetData } from '../selectors/dataSelector'

import Immutable from 'seamless-immutable'
import theme from './theme'

import NestedPieChart from './NestedPieChart'

const classes = ['Class 1', 'Class 2', 'Class 3', 'Class 4']

const styles = theme => ({})

class InfrastructureBufferChart extends PureComponent {
  render () {
    const { data, dataOuter } = this.props

    if (!arrayIsNotEmpty(data)) {
      console.log('data empty')
      return null
    }
    const width = 300
    const height = 300

    return (
      <NestedPieChart
        width={width}
        height={height}
        data={data}
        dataOuter={dataOuter}
        dataInner={data}
        categories={{ x: classes }}
        theme={theme}
      />
    )
  }
}

const transform = item => {
  // console.log(item)
  const data = item
  // return null
  const reducedData = data.reduce((object, item) => {
    const key =
      item.actualresidentialcount <= 11
        ? classes[0]
          : item.actualresidentialcount <= 26
          ? classes[1]
          : item.actualresidentialcount <= 45 ? classes[2] : classes[3]
    const prevCount = object[key]
    object[key] = prevCount ? prevCount + 1 : 1

    return object
  }, {[classes[0]]: 0, [classes[1]]: 0, [classes[2]]: 0, [classes[3]]: 0})
  const arrayData = Object.keys(reducedData).map(key => ({
    x: key,
    y: reducedData[key]
  }))

  const dataTransformed = Immutable(arrayData.sort((a, b) => a.x.localeCompare(b.x)))

  const total = dataTransformed.map(item => item.y).reduce((a, b) => a + b, 0)
  const dataTransformedTotal = dataTransformed.map(item => {
    return {...item, total: total}
  })

  return dataTransformedTotal
}

const transformOuter = item => {
  // console.log(item)
  // return null
  const data = item
  const reducedData = data.reduce((object, item) => {
    const key = item.residential_difference <0 ? 'misclassified' : 'correct'
    const prevCount = object[key]
    object[key] = prevCount ? prevCount + 1 : 1

    return object
  }, {})
  const arrayData = Object.keys(reducedData).map(key => ({
    x: key,
    y: reducedData[key]
  }))

  const dataTransformed = Immutable(arrayData.sort((a, b) => a.x.localeCompare(b.x)))
  const total = dataTransformed.map(item => item.y).reduce((a, b) => a + b, 0)
  const dataTransformedTotal = dataTransformed.map(item => {
    return {...item, total: total}
  })
  return dataTransformedTotal
}

// const transformFeatures = item => {
//   console.log('item')
//   console.log(item)
//   return item
// }

const transformFeatures = item => {
  console.log(item)
  // return null
  const data = item.propeprties
  const reducedData = data.reduce((object, item, index) => {
    console.log('index', index)
    const key = item.residential_difference <0 ? 'misclassified' : 'correct'
    const prevCount = object[key]
    object[key] = prevCount ? prevCount + 1 : 1

    return object
  }, {})
  const arrayData = Object.keys(reducedData).map(key => ({
    x: key,
    y: reducedData[key]
  }))

  const dataTransformed = Immutable(arrayData.sort((a, b) => a.x.localeCompare(b.x)))
  const total = dataTransformed.map(item => item.y).reduce((a, b) => a + b, 0)
  const dataTransformedTotal = dataTransformed.map(item => {
    return {...item, total: total}
  })
  return dataTransformedTotal
}

const makeMapStateToProps = () => {
  const getData = makeGetData()
  const getDataOuter = makeGetData()
  const getDataFeatures = makeGetData()
  const mapStateToProps = state => {
    return {
      data: getData(state, 'InfrastructurePipeline', transform),
      dataOuter: getDataOuter(state, 'InfrastructurePipeline', transformOuter),
      // features: getDataFeatures(state, 'InfrastructurePipelineFeatures', transformFeatures),
      // features: state.data
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(
  withStyles(styles)(InfrastructureBufferChart)
)



// WEBPACK FOOTER //
// ./src/charts/InfrastructurePieChart.js